import api from '../services/api';
import { PrivateClassType } from '../components/Forms/form-types';

export const sendPrivateClassRequest = (data: PrivateClassType) => {
    return api.post('/private-class-request', data).then((res) => res.data);
};
